// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlignCenterOutlinedSvg from "@ant-design/icons-svg/es/asn/AlignCenterOutlined";
import AntdIcon from '../components/AntdIcon';

var AlignCenterOutlined = function AlignCenterOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlignCenterOutlinedSvg
  }));
};

AlignCenterOutlined.displayName = 'AlignCenterOutlined';
export default React.forwardRef(AlignCenterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AlignCenterOutlined.js
// module id = 537
// module chunks = 0